export default __webpack_public_path__ + "static/media/nodejsfront.a4de4b44.svg";